// ---------------------------------------------------------------
// useConexion.js — ¿Hay conexión ahora mismo?
//
// Firestore guarda en el móvil lo que no puede enviar y lo sincroniza
// cuando vuelve la cobertura, así que fichar sin wifi FUNCIONA. El
// problema es que el empleado ve exactamente el mismo "Entrada
// registrada" que si hubiera llegado al servidor, y en un registro
// con valor legal eso da lugar a dudas ("¿se habrá guardado?").
//
// Esto sólo informa: no bloquea nada ni cambia el comportamiento.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";

export function useConexion() {
  const [enLinea, setEnLinea] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine
  );

  useEffect(() => {
    const arriba = () => setEnLinea(true);
    const abajo = () => setEnLinea(false);
    window.addEventListener("online", arriba);
    window.addEventListener("offline", abajo);
    return () => {
      window.removeEventListener("online", arriba);
      window.removeEventListener("offline", abajo);
    };
  }, []);

  return enLinea;
}
